import React, { useState, useContext, createContext, useEffect } from 'react';
import { Table, Input, Button, Popconfirm, Form, DatePicker,InputNumber } from 'antd';
import 'antd/dist/antd.css';
import Currency from '../../../components/form/Currency'; // Adjust the import path as necessary
import moment from 'moment';
import { ToolTipCreator } from '../../../helpers/ToolTipCreator';

const EditableContext = createContext();

const EditableRow = ({ form, index, ...props }) => (
  <EditableContext.Provider value={form}>
    <tr {...props} />
  </EditableContext.Provider>
);

const EditableFormRow = Form.create()(EditableRow);

const EditableCell = ({
  editable,
  children,
  dataIndex,
  title,
  record,
  handleSave,
  fields,
  handleChange,
  ...restProps
}) => {
  const [editing, setEditing] = useState(false);
  const form = useContext(EditableContext);

  const toggleEdit = () => {
    setEditing(!editing);
    if (!editing && record) {
      form.setFieldsValue({
        [dataIndex]: record[dataIndex],
      });
    }
  };

  const renderField = () => {
    const fieldConfig = fields.find(field => field.name === dataIndex) || {};
    const { type } = fieldConfig;

    const handleFieldChange = e => {
      const value = e && e.target ? e.target.value : e; // handle DatePicker case
      handleChange(dataIndex, value, record.key);
    };
    const handleInputChange = (val) => {
      const value = val; // handle currency case
      handleChange(dataIndex, value, record.key);
    };
    console.log("type",fields,fieldConfig,type, record[dataIndex])
    switch (type) {
      case 'date':
        const date = record[dataIndex] ? moment(record[dataIndex]).format('YYYY-MM-DD') : '';
      console.log("record:", record[dataIndex],record, "formatted date:", date);
        return <Input type='date' value={date} onChange={handleFieldChange} />;
      case 'float':
        const isPercentField = dataIndex && dataIndex.includes('%');
        const inputNumber = <InputNumber
        step={1}
        formatter={(value) => {
          if (isPercentField) {
            return (value !== undefined && value !== null ? `${value}` : '').replace(/\B(?=(\d{3})+(?!\d))/g, ',');
          }
          return `$ ${value !== undefined && value !== null ? value : ''}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
        }}
        value={record && record[dataIndex]}
        parser={(value) =>
          isPercentField
            ? value.replace(/%\s?|(,*)/g, "")
            : value.replace(/\$\s?|(,*)/g, "")
        }
        className="InputCurrency"
        onChange={(value) => {
          handleInputChange(value);
        }}
        style={{ width: '100%' }}
      />;
        return isPercentField ? (
          <div style={{
            display: 'flex',
            alignItems: 'center',
            border: '1px solid #d9d9d9',
            borderRadius: '4px',
            overflow: 'hidden',
            width: '100%',
          }}>
            <div style={{ flex: 1 }}>
              {React.cloneElement(inputNumber, { style: { width: '100%', border: 'none', boxShadow: 'none' } })}
            </div>
            <span style={{
              padding: '0 4px',
              background: '#f5f5f5',
              borderLeft: '1px solid #d9d9d9',
              color: '#595959',
              fontWeight: 500,
              display: 'flex',
              alignItems: 'center',
              height: '100%',
              whiteSpace: 'nowrap',
            }}>%</span>
          </div>
        ) : inputNumber;
      case 'int':
        return <Input onChange={handleFieldChange} />;
      case 'string': return <Input onChange={handleFieldChange} />;
      default:
        return <Input onChange={handleFieldChange} />;
    }
  };

  return (
    <td {...restProps}>
      {editable ? (
        <Form.Item style={{ margin: 0 }}>
          {form.getFieldDecorator(dataIndex, {
            rules: [{ required: true, message: `${title} is required.` }],
            initialValue: record ? record[dataIndex] : '', // Ensure initialValue is set
          })(renderField())}
        </Form.Item>
      ) : (
        <div
          className="editable-cell-value-wrap"
          style={{ paddingRight: 24 }}
          onClick={toggleEdit}
        >
          {children}
        </div>
      )}
    </td>
  );
};

const GoalSubFormTable = ({ title, rows, colsFormat, addNewButton, cbFormChange,deleteAssignAsset }) => {
  const [dataSource, setDataSource] = useState(rows);
  const [count, setCount] = useState(rows.length + 1);
  // const formatDatesInRows = (rows) => {
  //   return rows.map(row => {
  //     const newRow = { ...row };
  //     console.log("newRow",newRow)
  //     Object.keys(newRow).forEach(key => {
  //       if (moment(newRow[key], moment.ISO_8601, true).isValid()) {
  //         newRow[key] = moment(newRow[key]).format('YYYY-MM-DD');
  //       }
  //     });
  //     return newRow;
  //   });
  // };
  const formatDatesInRows = (rows) => {
    return rows.map(row => {
      const newRow = { ...row };
      Object.keys(newRow).forEach(key => {
        // Check if the value is a valid date string and not just a number
        const value = newRow[key];
        if (typeof value === 'string' && moment(value, moment.ISO_8601, true).isValid()) {
          // Further ensure it's a date by checking for specific date patterns
          const date = moment(value);
          if (date.isValid() && date.year() > 1900 && date.year() < 2100) {
            newRow[key] = date.format('YYYY-MM-DD');
          }
        }
      });
      return newRow;
    });
  };
  useEffect(()=>{
    console.log("allrows",rows)
    if(title==="Assets to Assign to Goal"){
      setDataSource(rows)
    }
    else{
      const formattedRows = formatDatesInRows(rows);
      console.log("formattedRows",formattedRows,rows)
      setDataSource(formattedRows);
    }
    // setDataSource(rows)
  },[rows])
  console.log("NewRows",rows,dataSource)

  const handleDelete = record => {
    const newData = dataSource && dataSource.filter(item => item.key != record.key || item.id != record.id);
    setDataSource(newData);
    cbFormChange(newData);
    console.log("dataSourceDelete",dataSource,record,newData)
    deleteAssignAsset(record)
  };

  const handleAdd = () => {
    const newData = {
      key: count.toString(),
      ...colsFormat.reduce((acc, col) => {
        col.fields.forEach(field => {
          acc[field.name] = ''; // Set default value for each field
        });
        return acc;
      }, {})
    };
    setDataSource([...dataSource, newData]);
    setCount(count + 1);
    cbFormChange([...dataSource, newData]);
  };

  const handleSave = row => {
    const newData = [...dataSource];
    const index = newData.findIndex(item => row.key === item.key);
    if (index > -1) {
      newData.splice(index, 1, { ...newData[index], ...row });
      setDataSource(newData);
      cbFormChange(newData);
    }
  };

  const handleChange = (dataIndex, value, key) => {
    const newData = dataSource.map(item => {
      if (item.key === key) {
        return { ...item, [dataIndex]: value };
      }
      return item;
    });
    setDataSource(newData);
    cbFormChange(newData);
  };

  const generateColumns = (colsFormat) => {
    return colsFormat.map(col => ({
      title: col.title,
      dataIndex: col.dataIndex,
      key: col.key,
      editable: true,
      render: (text, record) => (
        <EditableCell
          editable={addNewButton ? true : false}
          dataIndex={col.dataIndex}
          title={col.title}
          record={record}
          fields={col.fields}
          handleSave={handleSave}
          handleChange={handleChange}
        >
          {text}
        </EditableCell>
      ),
    })).concat([{
      title: 'Action',
      dataIndex: 'action',
      render: (_, record) =>
        dataSource.length >= 1 && addNewButton ? (
          <React.Fragment>
            <Popconfirm title="Sure to delete?" onConfirm={() => handleDelete(record)}>
              <span className='goalTableDeleteButton'>{title === "Other Retirement Income" ? "Exclude" : "Delete"}</span>
            </Popconfirm>
          </React.Fragment>
        ) : null,
    }]);
  };

  const columns = generateColumns(colsFormat);

  const components = {
    body: {
      row: EditableFormRow,
      cell: EditableCell,
    },
  };
  return (
    <div style={{ width: "100%" }}>
      <div className='goalSubFormTable' >
      <div className='goalSubFormTableHeader'>
      <div style={{display:'flex', alignItems:'baseline', columnGap:'3px'}}>
        <h3 className='incomecardheading'>{title}</h3>
        {["Assets to Assign to Goal", "Assign savings to goal", "Current Information"].includes(title) && (
            <ToolTipCreator
              name={
                title === "Assets to Assign to Goal"
                ? "Goals_Assets_to_Assign_to_Goal"
                : title === "Assign savings to goal"
                ? "Goals_Assign_savings_to_Goal"
                : title === "Current Information"
                ? "Goals_Current_Information"
                : ""
              }
            />
        )}
      </div>
          {(addNewButton && title!=="Assets to Assign to Goal") && (
            <div
              style={{
                fontSize: "15px",
                display: "flex",
                alignItems: "center",
                fontWeight: "600",
                fontFamily: "Poppins",
                border: "none",
                borderRadius: "4.36px",
                backgroundColor: "#2a3da3",
                color: "white",
                cursor: "pointer",
                padding: "5px 9px",
                height: "28px",
                width: "28px",
              }}
              onClick={handleAdd}
            >
              +
            </div>
          )}
        </div>
        <Table
          components={components}
          rowClassName="editable-row"
          dataSource={dataSource}
          columns={columns && columns.filter(col => col.dataIndex !== 'asset_id' && col.dataIndex !== 'assetId' && col.dataIndex !== 'goal_status')}
          pagination={false}
        />
      </div>
    </div>
  );
};

export default GoalSubFormTable;